module.exports = {
  pages: [
    {
      title: 'Selected Works | Yuvin Ha',
      name: 'index',
      private: false,
    },
    {
      title: 'About | Yuvin Ha',
      name: 'about',
      private: false,
    },
    {
      title:
        'VolunGO | A dual platform for intelligent matching of volunteers and nonprofit organizations',
      name: 'volungo',
      private: false,
    },
    {
      title:
        'Virtual Rewards in Real Life | A Gimmick or a Motivational Tool for Promoting Physical Activity?',
      name: 'virtual-rewards',
      private: false,
    },
    {
      title: 'CS eXpert | Designing for Experience of CS Agents',
      name: 'cs-expert',
      private: false,
    },
    {
      title: 'Yhteispot | Designing for Responsible Leisure Activities',
      name: 'yhteispot',
      private: false,
    },
    {
      title: 'Family Now | Exploring IoT-Based Services',
      name: 'family-now',
      private: true,
    },
    {
      title: 'Live Menu | UI/UX Design of a Smart TV App',
      name: 'live-menu',
      private: true,
    },
    {
      title: 'New Black | UI/UX Design For The Next LG Smart TV Platform',
      name: 'new-black',
      private: true,
    },
    {
      title: 'Shadow Zoo | Play Together with Hand Shadows',
      name: 'shadow-zoo',
      private: false,
    },
    {
      title: 'Umbrella | Physical Visualization of a Chance of Rain',
      name: 'umbrella',
      private: false,
    },
    {
      title: 'Your Heartbeat | Feel Your Heartbeat with Eyes and Ears',
      name: 'heartbeat',
      private: false,
    },
  ],
  works: [
    // {
    //   type: 'featured',
    //   name: 'volungo',
    //   title: 'VolunGO',
    //   subTitle:
    //     'A dual platform for intelligent matching of volunteers and nonprofit organizations',
    //   private: false,
    //   file: 'png',
    //   category: 'Product Design',
    //   date: '2021',
    // },
    // {
    //   type: 'featured',
    //   name: 'cs-expert',
    //   title: 'CS eXpert',
    //   subTitle: 'Designing for Experience of Customer Service Agents',
    //   private: false,
    //   file: 'png',
    //   category: 'UX Design',
    //   date: '2018',
    // },
    // {
    //   type: 'featured',
    //   name: 'yhteispot',
    //   title: 'Yhteispot',
    //   subTitle:
    //     'Designing a Collaborative Service Model for Responsible Leisure Activities',
    //   private: false,
    //   file: 'png',
    //   category: 'Service Design',
    //   date: '2018',
    // },
    // {
    //   type: "design",
    //   name: "virtual-rewards",
    //   title: "Virtual Rewards in Real Life",
    //   subTitle:
    //     "A Gimmick or a Motivational Tool for Promoting Physical Activity?",
    //   private: false,
    //   file: "png",
    //   category: "UX Research",
    //   date: "2019",
    // },
    {
      type: 'more-works',
      name: 'family-now',
      title: 'Family Now',
      subTitle: 'Exploring IoT-Based Services in the Hyper-Connected World',
      private: true,
      file: 'png',
      category: 'Service Concept Design',
      date: '2014',
    },
    {
      type: 'more-works',
      name: 'live-menu',
      title: 'Live Menu',
      subTitle:
        'UI/UX Design of a Smart TV App for Simplified Content Discovery',
      private: true,
      file: 'png',
      category: 'UX/UI Design',
      date: '2013',
    },
    {
      type: 'more-works',
      name: 'new-black',
      title: 'New Black',
      subTitle: 'UI/UX Design for the Next LG Smart TV Platform',
      private: true,
      file: 'png',
      category: 'UX/UI Design',
      date: '2012',
    },
    // {
    //   type: 'more-works',
    //   name: 'shadow-zoo',
    //   title: 'Shadow Zoo',
    //   subTitle: 'Play Together with Hand Shadows',
    //   private: false,
    //   file: 'jpg',
    //   category: 'Interaction Design',
    //   date: '2019',
    // },
    // {
    //   type: 'more-works',
    //   name: 'umbrella',
    //   title: 'Umbrella',
    //   subTitle: 'Physical Visualization of a Chance of Rain',
    //   private: false,
    //   file: 'jpg',
    //   category: 'Interaction Design',
    //   date: '2019',
    // },
    /*     
    {
      type: "experiment",
      name: "heartbeat",
      title: "Your Heartbeat",
      subTitle: "Feel Your Heartbeat With Eyes And Ears",
      private: false,
      category: "Interaction Design",
      date: "2018",
    }, 
    */
  ],
};
